import WorkspaceHorizonLogoSVG from '~/assets/workspace-logo-horizon.svg';

export default function WorkspaceHorizonLogo({
    height = 64,
}: {
    height?: number;
}) {
    return (
        <img
            src={WorkspaceHorizonLogoSVG}
            alt="MVision Workspace+"
            width="auto"
            height={height}
            style={{ pointerEvents: 'none' }}
        />
    );
}
